function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { createPortal } from "react-dom";
export function renderWithPortal(renderElement, portal) {
    switch(true){
        case portal === true:
            return portalToBody(renderElement);
        case typeof portal === 'string':
            return portalToId(renderElement, portal);
        case _instanceof(portal, Object):
            return portalToRef(renderElement, portal);
        default:
            return renderElement;
    }
}
export default renderWithPortal;
function portalToBody(renderElement) {
    return createPortal(renderElement, document.body);
}
function portalToId(renderElement, portal) {
    var portalElement = document.getElementById(portal);
    if (portalElement) {
        return createPortal(renderElement, portalElement);
    }
}
function portalToRef(renderElement, portal) {
    if (portal.hasOwnProperty('current')) {
        if (_instanceof(portal.current, Element)) {
            return createPortal(renderElement, portal.current);
        }
    } else if (_instanceof(portal, Element)) {
        return createPortal(renderElement, portal);
    }
}
